import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'
import { notification } from 'antd'

export function useModelConfig() {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const queryClient = useQueryClient()

  const siteConfigQuery = useQuery({
    queryKey: ['best_buy/get_model_config'],
    queryFn: async () => {
      const config = await api.post('best_buy/get_model_config', {})
      return config as Gravitate.ModelConfig
    },
  })

  const setConfigMutation = useMutation({
    mutationFn: (config: Gravitate.ModelConfig) => api.post('best_buy/set_model_config', config),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['best_buy/get_model_config'],
      }),
    onError: () => notification.error({ message: 'Failed to save model config!' }),
  })

  return {
    config: siteConfigQuery.data ?? ({} as Gravitate.ModelConfig),
    setConfig: setConfigMutation.mutate,
    isLoading: siteConfigQuery.isPending,
    isError: siteConfigQuery.isError,
  }
}
